/**
 *    This middleware is responsible for intercepting actions that
 *    we want to affect the route.
 */
import {constants as kandyConstants} from 'kandy-redux'
import {isFSA} from 'flux-standard-action'

let loginFinish = ({dispatch, action,getState}) => {

	if (!action.error) {
		// console.log("routing middleware dashboard",getState().app);
		// //dispatch(pushState(null, '/dashboard'))
		// dispatch(push('/workBench'));
	} else {

	}
}

let logout = ({dispatch, getState}) => {
	// dispatch(replace('/' + config.companyId + '/login'))
}

const interceptors = {}
interceptors[kandyConstants.LOGIN_FINISH] = loginFinish
interceptors[kandyConstants.LOGOUT] = logout

let middleware = ({dispatch, getState}) => {
	return next => action => {
		if (isFSA(action) && interceptors[action.type]) {
			interceptors[action.type]({dispatch, getState, action})
		}

		return next(action)
	};
}

export default middleware
